var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-col',{attrs:{"sm":"6"}},[_c('mdb-card',[_c('mdb-card-body',[_c('mdb-card-title',[_vm._v("Login")]),_c('mdb-card-text',[_vm._v("\n            \n     Login \n            \n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }